import React from 'react';

import api from '../../../../api/api';
import ParadigmaTable from "../../../../components/ParadigmaTable/ParadigmaTable";
import Modal from "./Modal.js";


const columns = [
    {
        Header: "id",
        id: "id",
        accessor: "id",
        width: 100,
        show: false,
        private: true,
    },
    {
        Header: "Nombre",
        id: "full_name",
        accessor: "full_name",
        show: true,
        width: 300,
    },
    {
        Header: "Email",
        id: "email",
        accessor: "email",
        filterable: true,
        show: true,
    },
    {
        Header: "Activo",
        id: "is_active",
        className: "text-center",
        accessor: d => (d.is_active ? "SI" : "NO"),
        filterable: true,
        width: 100,
        show: true,
    },
]

const Inversionistas = (props) => {

    const { modernTheme } = props;

    return (
        <ParadigmaTable
            modernTheme={modernTheme}
            buttons={[
                {
                    edit: true,
                    permission: 'usuarios_usuarios_edit',
                    component: (props) => <Modal {...props} action="EDIT" />,
                },
            ]}
            apiUrl={api.gestion.precios.consultadores}
            columns={columns}
            title={"Asignar Lista de Precios"}
        />
    );
}

export default Inversionistas;



// WEBPACK FOOTER //
// ./src/views/Gestion/Precios/Asignar/Asignar.js